import verifiedPaddingPaths from './catalogModalImagePadding.json';

const paddedImages = new Set<string>(verifiedPaddingPaths);

// This profile is tied to immutable migration object keys, not category IDs.
// An unknown/replaced image keeps contain, so future square/tall photos stay whole.
export const hasVerifiedCatalogPadding = (icon?: string | null): boolean => {
  if (!icon) return false;
  const path = icon.split(/[?#]/, 1)[0].replace(/^\/+/, '');
  return paddedImages.has(path);
};
